import React, { FC } from 'react';
import { Modal, ProgressBar } from 'react-bootstrap';

import { FlexSpinner } from '../common';

type Props = {
  readonly show: boolean;
  readonly progress: number;
  readonly title?: string;
};

const ModalSpinner: FC<Props> = ({ title = 'Παρακαλώ περιμένετε...', show, progress }) => {
  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FlexSpinner />
        {progress > 0 && <ProgressBar now={progress} />}
      </Modal.Body>
    </Modal>
  );
};

export default ModalSpinner;

